'use client';

import { c as _c } from "react/compiler-runtime";
import { useGetMarkets } from '@morfi/backend-sdk-v2/client';
import { type ReactNode, useEffect } from 'react';
import { logger } from '@/lib/telemetry/logger';

// A batch must fit one SDK page (24) and the API's 50-pubkey filter cap.
const CREATOR_BATCH_SIZE = 24;
const EMPTY_CREATED_IDS: readonly string[] = [];
export function PortfolioProposalCreators(t0) {
  const $ = _c(28);
  const {
    userId,
    pubkeys,
    children,
    createdIds: t1
  } = t0;
  const createdIds = t1 === undefined ? EMPTY_CREATED_IDS : t1;
  let batch;
  let remaining;
  let t2;
  let t3;
  let t4;
  if ($[0] !== pubkeys || $[1] !== userId) {
    batch = pubkeys.slice(0, CREATOR_BATCH_SIZE);
    let t5;
    if ($[7] !== pubkeys) {
      t5 = pubkeys.slice(CREATOR_BATCH_SIZE);
      $[7] = pubkeys;
      $[8] = t5;
    } else {
      t5 = $[8];
    }
    remaining = t5;
    t4 = useGetMarkets;
    t2 = userId;
    t3 = batch.join(",");
    $[0] = pubkeys;
    $[1] = userId;
    $[2] = batch;
    $[3] = remaining;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    batch = $[2];
    remaining = $[3];
    t2 = $[4];
    t3 = $[5];
    t4 = $[6];
  }
  let t5;
  if ($[9] !== t2 || $[10] !== t3) {
    t5 = {
      creatorUserId: t2,
      pubkeys: t3,
      status: "created,backing,trading,resolved,graduated"
    };
    $[9] = t2;
    $[10] = t3;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const t6 = userId.length > 0 && batch.length > 0;
  let t7;
  if ($[12] !== t6) {
    t7 = {
      enabled: t6
    };
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  const query = t4(t5, t7);
  const failed = query.isError;
  let t8;
  let t9;
  if ($[14] !== batch.length || $[15] !== failed) {
    t8 = () => {
      if (failed) {
        logger.warn("portfolio.proposal_positions.creator_lookup_failed", {
          batchSize: batch.length
        });
      }
    };
    t9 = [failed, batch.length];
    $[14] = batch.length;
    $[15] = failed;
    $[16] = t8;
    $[17] = t9;
  } else {
    t8 = $[16];
    t9 = $[17];
  }
  useEffect(t8, t9);
  let t10;
  let t11;
  if ($[18] !== children || $[19] !== createdIds || $[20] !== failed || $[21] !== query.isPending || $[22] !== query.isPlaceholderData || $[23] !== query.rows || $[24] !== remaining || $[25] !== userId) {
    t11 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const matches = failed || query.isPending || query.isPlaceholderData ? createdIds : [...createdIds, ...query.rows.map(_temp)];
      if (remaining.length > 0) {
        t11 = <PortfolioProposalCreators userId={userId} pubkeys={remaining} createdIds={matches}>{children}</PortfolioProposalCreators>;
        break bb0;
      }
      t10 = children(new Set(matches));
    }
    $[18] = children;
    $[19] = createdIds;
    $[20] = failed;
    $[21] = query.isPending;
    $[22] = query.isPlaceholderData;
    $[23] = query.rows;
    $[24] = remaining;
    $[25] = userId;
    $[26] = t10;
    $[27] = t11;
  } else {
    t10 = $[26];
    t11 = $[27];
  }
  if (t11 !== Symbol.for("react.early_return_sentinel")) {
    return t11;
  }
  return t10;
}
function _temp(row) {
  return row.pubkey;
}